<events-event-editor
  *ngIf="groupId"
  [groupId]="groupId"
  [eventId]="eventId"
  (eventSaved)="afterSaved($event)"
></events-event-editor>
